export type SortOrder = 'asc' | 'desc';

/**
 * Ordena una copia del array por la clave indicada.
 * Números: comparación numérica. Resto: string case-insensitive (útil para fechas ISO y textos).
 */
export function sortByField<T>(
  items: T[],
  orderBy: keyof T | '',
  order: SortOrder
): T[] {
  if (!orderBy) return items;
  return [...items].sort((a, b) => {
    let aValue: unknown = a[orderBy];
    let bValue: unknown = b[orderBy];
    if (aValue == null) aValue = '';
    if (bValue == null) bValue = '';
    if (typeof aValue === 'number' && typeof bValue === 'number') {
      return order === 'asc' ? aValue - bValue : bValue - aValue;
    }
    const aStr = String(aValue).toLowerCase();
    const bStr = String(bValue).toLowerCase();
    if (order === 'asc') return aStr < bStr ? -1 : aStr > bStr ? 1 : 0;
    return aStr > bStr ? -1 : aStr < bStr ? 1 : 0;
  });
}
